import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconMoneyScorecardGold } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { ProductAvailabilityNotificationGoldMessageComponent } from './product-availability-notification-gold-message.component';

@NgModule({
	declarations: [ProductAvailabilityNotificationGoldMessageComponent],
	imports: [
		CommonModule,
		HmfTextLinkComponent,
		HomefieldIconLibraryModule
	],
	exports: [ProductAvailabilityNotificationGoldMessageComponent]
})
export class ProductAvailabilityNotificationGoldMessageModule {
	constructor(
		private resolver: ComponentFactoryResolver,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconMoneyScorecardGold
		]);
	}

	public resolveComponentFactory(): ComponentFactory<ProductAvailabilityNotificationGoldMessageModule> {
		return this.resolver.resolveComponentFactory(ProductAvailabilityNotificationGoldMessageModule);
	}
}
